import * as React from 'react';
import * as moment from 'moment';

import { connect, Dispatch } from 'react-redux';
import { IEventMonth, ICalendarState, RawActions } from '@adage/ace-calendar';
import { create } from '@adage/calendar';
import { IArenaEvent } from '../classes/event';
import DesktopContainer from './desktop-container';
import Example from '../ex-comp';
import Filter from './Filter';
import { ICalendar } from "@adage/calendar/services/calendar";
import Exit from '../views/exit';
import AccessibilitySelection from '../components/accessibility-selection';

import MediaQuery from 'react-responsive';
//var MediaQuery: React.ComponentClass<MediaQueryProps> = require('react-responsive');

interface CalendarExternalProps {
    numberOfMonth: number
}

interface CalendarStateFromProps {
    evts: Array<IEventMonth<IArenaEvent>>;
    loading: boolean
}



type CalendarProps = CalendarStateFromProps & CalendarExternalProps;

interface CalendarState {
    calendarMonths: Array<ICalendar<IArenaEvent>>;
    allMonths: Array<moment.Moment>;
    emptyMonths: Array<moment.Moment>;
    firstLoad: boolean
}

class CalendarApp extends React.Component<CalendarProps, CalendarState> {
    /**
     * Lifecycle functions.
     * @param props
     */
    constructor(props: CalendarProps) {
        super(props);

        const eventMonths = this.createCalendarFromEvents(props.evts);
        const emptyMonths = eventMonths.filter(cal => cal.days.every(day => day.events.length === 0)).map(cal => moment(cal.days[0].date));

        this.state = {
            calendarMonths: eventMonths,
            allMonths: props.evts.map(evtMonth => evtMonth.monthMoment),
            emptyMonths: emptyMonths,
            firstLoad: true
        };
    }

    componentWillReceiveProps(props: CalendarProps) {

        const eventMonths = this.createCalendarFromEvents(props.evts);
        const emptyMonths = eventMonths.filter(cal => cal.days.every(day => day.events.length === 0)).map(cal => moment(cal.days[0].date));

        this.setState({
            calendarMonths: eventMonths,
            allMonths: props.evts.map(evtMonth => evtMonth.monthMoment),
            emptyMonths: emptyMonths,
            firstLoad : false
        })
    }

    /**
     * Helper functions.
     */
    private createCalendarFromEvents(evts: Array<IEventMonth<IArenaEvent>>) {
        const today = moment().clone().startOf("day");

        for (let evtMonth of evts) {
            // Skip if it's a month in the future.
            if (evtMonth.monthMoment.clone().startOf("month").isSame(moment().startOf("month")))
                break;

            evtMonth.events = evtMonth.events.filter(event => {
                const eventDate = moment(event.eventDate).startOf("day");

                return eventDate.isAfter(today);
            });
        }

        return evts.map(eventMonth => create({
            events: eventMonth.events,
            month: eventMonth.monthMoment.month(),
            year: eventMonth.monthMoment.year(),
            weekdayNames: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
        }));
    }

    private transitionWidth = '80rem';

    /**
     * Render function.
     */
    render() {
        return (
            <div className="cal-container">

                <MediaQuery query={`(min-width: ${this.transitionWidth})`}>
                    <Filter numberOfMonth={this.props.numberOfMonth} isMobile={false} invalidMonths={this.state.emptyMonths} />
                </MediaQuery>

                <MediaQuery query={`(max-width: ${this.transitionWidth})`}>
                    <Filter numberOfMonth={this.props.numberOfMonth} isMobile={true} invalidMonths={this.state.emptyMonths} />
                </MediaQuery>

                <div className="cal-grid-container">
                    <Exit />
                    <MediaQuery query={`(min-width: ${this.transitionWidth})`}>
                        {
                            this.state.firstLoad && this.props.loading ? <div className={`loader-container`} ><div className="loader">Loading&hellip;</div></div> :null
                        }
                        <DesktopContainer allMonths={this.state.allMonths} calendarMonths={this.state.calendarMonths} evts={this.props.evts} isMobile={false} />
                    </MediaQuery>

                    <MediaQuery query={`(max-width: ${this.transitionWidth})`}>
                        <DesktopContainer allMonths={this.state.allMonths} calendarMonths={this.state.calendarMonths} evts={this.props.evts} isMobile={true} />
                    </MediaQuery>

                </div>
            </div>
        )
    }
}

function mapStateToProps(state: ICalendarState<IArenaEvent>, externalProps: CalendarProps) {
    return {
        evts: state.events,
        loading: state.updating
    }
}



export default connect<CalendarStateFromProps, null>(mapStateToProps, null)(CalendarApp);


// WEBPACK FOOTER //
// ./app/calendar/components/app.tsx